import { Scissors } from "lucide-react";

// Iter 125 — marks articles that came from an Intercom content snippet, so
// staff know the source (and that edits belong in Intercom, not here).
export function KbSnippetPill({ className = "" }) {
  return (
    <span
      data-testid="kb-snippet-pill"
      title="Imported from an Intercom content snippet — edit it in Intercom"
      className={`inline-flex shrink-0 items-center gap-1 rounded-full bg-violet-50 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-violet-700 ring-1 ring-violet-200 ${className}`}
    >
      <Scissors className="h-2.5 w-2.5" /> Snippet
    </span>
  );
}
